import { FilterItemType } from '../../../../types/types';
import { getFilterMatchModes } from '../../../../utils/filters/getFilterMatchModes';

type MatchModeType = {
  label: string;
  value: string;
};

export const getMatchModes = (
  column: any,
  filterItem: FilterItemType | undefined
): MatchModeType[] =>
  getFilterMatchModes(filterItem, column.type).map(({ label, name }) => ({
    label,
    value: name,
  }));
